module.exports = __webpack_public_path__ + "static/media/group1-mobile.b41afdff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group1-mobile.svg
// module id = 1358
// module chunks = 0